var _defs, _path, _path2, _path3, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "70.21mm",
    height: "24.53mm",
    viewBox: "0 0 199.03 69.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4a49;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 150.45,
    y1: 2.77,
    x2: 164.21,
    y2: 65.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#970165"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#790c5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#611656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#511c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#47204e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#44214d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#401a47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#360638"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 80.01,
    y1: 16.34,
    x2: 101.77,
    y2: 115.91,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.1,69.54H0V1H25.17C40.79,1,46,8.81,46,19a17.51,17.51,0,0,1-7.72,14.15A19.33,19.33,0,0,1,48.87,50.52c0,9.83-7,19-21.77,19M16.35,14.05V28.84H21c6.79,0,10.47-2.57,10.47-7.44,0-4.69-2.3-7.35-10.2-7.35Zm0,26.09V56.49h5.7c8.08,0,10.38-3.21,10.38-8,0-5.6-3.58-8.36-10.57-8.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.82,22a2.32,2.32,0,0,1-.93.7,6.29,6.29,0,0,1-2.76.53,9.5,9.5,0,0,1-6.47-2.67l-2.89,5.59a32.08,32.08,0,0,0,4.38,2.38,14.23,14.23,0,0,0,2.69.8l1.86-2.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M150.34,28.6H134.42V1h7.21V22.34h8.71Zm27-27.6H170V18.3a4.32,4.32,0,0,1-1.35,3.4,5.15,5.15,0,0,1-3.56,1.2q-5,0-5-5V1H153V19.46A8.8,8.8,0,0,0,156.67,27,13.76,13.76,0,0,0,165,29.39a13.58,13.58,0,0,0,8.7-2.6,9.76,9.76,0,0,0,3.63-8.13ZM194,12.28l-3-1.18a15.36,15.36,0,0,1-2.11-.91,1.91,1.91,0,0,1-1-1.62c0-1.61.92-2.41,2.76-2.41a8.09,8.09,0,0,1,5.55,2.2L199,3a16.05,16.05,0,0,0-8.81-3,9.81,9.81,0,0,0-6.58,2.32,8.18,8.18,0,0,0-2.9,6.48q0,5.5,5.4,8c1,.47,2.39,1,4.12,1.65a7.1,7.1,0,0,1,2.44,1.3,2,2,0,0,1,.44,1.41,1.46,1.46,0,0,1-.31.92l5.56-6.8a11.13,11.13,0,0,0-4.35-3M129.45,3.66a9.46,9.46,0,0,1,2.29,6.61,8.69,8.69,0,0,1-2.29,6.27A8.09,8.09,0,0,1,123.28,19H118V28.6h-7.21V19h-5.3V13.69h6.26L122.36,1h.69a8.15,8.15,0,0,1,6.4,2.66m-9.12,10q4.24,0,4.25-3.72,0-3.53-4.18-3.53h-2.61v7.25h2.54"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.91 69.54 115.94 69.54 88.79 29.74 112.9 1 92.97 1 71.75 26.26 71.75 1 55.4 1 55.4 45.72 55.4 45.72 55.4 69.48 55.4 69.54 71.75 69.54 71.75 50.05 77.86 42.77 95.91 69.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "112.9 1 92.97 1 55.4 45.72 55.4 69.54 112.9 1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e4830e4b8d2b1fe9cef15e8b5e708b8d.svg";
export { ForwardRef as ReactComponent };